import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/manage-deputy-merchant';

const list = (merchantId) => {
	return Client.get(`${baseUrl}/${merchantId}/deputyMerchantSettings`, {
		status: 0,
	});
};

const find = (merchantId, id) => {
	return Client.get(`${baseUrl}/${merchantId}/deputyMerchantSettings/${id}`);
};

const create = (
	merchantId,
	deputyToken,
	deputyUrl,
	operateBy,
	stopFlag = false
) => {
	return Client.post(`${baseUrl}/${merchantId}/deputyMerchantSettings`, {
		deputyToken,
		deputyUrl,
		operateBy,
		stopFlag,
	});
};

const update = (
	merchantId,
	id,
	deputyToken,
	deputyUrl,
	operateBy,
	stopFlag = false
) => {
	return Client.put(`${baseUrl}/${merchantId}/deputyMerchantSettings/${id}`, {
		deputyToken,
		deputyUrl,
		operateBy,
		stopFlag,
	});
};

const remove = (merchantId, id, operateBy) => {
	return Client.del(`${baseUrl}/${merchantId}/deputyMerchantSettings/${id}`, {
		operateBy,
	});
};

export default {
	list,
	find,
	create,
	update,
	remove,
};
